module.exports = __webpack_public_path__ + "img/link-banner-th.d3df3f01.png";